<template>
  <div>
    <b-row class="mb-2">
      <filter-creatives :is-admin="isAdmin" />
      <div class="table-responsive">
        <b-table
          class="mb-0"
          hover
          bordered
          :fields="tableFields"
          :items="list"
        >
          <template v-if="isAdmin" slot="userId" slot-scope="{ item }">
            <router-link
              :to="{
                name: 'hunter-profile-admin',
                params: { userId: item.ownerID }
              }"
            >
              {{ item.ownerID }}
            </router-link>
          </template>
          <template slot="status" slot-scope="{ item }">
            <b-badge :variant="statusClass(item.status)" class="text-uppercase">
              {{ item.status }}
            </b-badge>
            <div v-if="item.status === 'rejected' && item.rejectDescription">
              <hr />
              Reason:
              <span class="text-light">{{ item.rejectDescription }}</span>
            </div>
          </template>
          <template slot="format" slot-scope="{ item }">
            {{ item.type }}
            <span v-if="item.image">
              - {{ item.image.width }}x{{ item.image.height }}
            </span>
          </template>
          <template slot="creative" slot-scope="{ item }">
            <a v-if="item.image" :href="item.image.mediaUrl" target="_blank">
              <img
                :src="item.image.mediaUrl"
                class="creative-preview"
                v-b-tooltip.hover
                :title="`Image: ${item.image.mediaUrl}`"
              />
            </a>
            <a v-else :href="item.video.mediaUrl" target="_blank">
              <svg-icon
                icon="play"
                class="icon-xl"
                v-b-tooltip.hover
                :title="`Video file: ${item.video.mediaUrl}`"
              />
            </a>
          </template>
          <template slot="actions" slot-scope="{ item }">
            <button
              v-if="!isAdmin"
              class="btn-link-alt btn-link-primary"
              title="Delete creative"
              v-b-tooltip.hover
              @click="deleteCreative(item.id)"
            >
              <svg-icon icon="trash" class="icon-xl" />
            </button>
            <button
              v-if="$can('update', 'Creative')"
              class="btn-link-alt btn-link-primary"
              title="Edit"
              @click="editCreative(item)"
              v-b-tooltip.hover
            >
              <svg-icon icon="pencil" class="icon-xl" />
            </button>
          </template>
        </b-table>
      </div>
    </b-row>

    <b-modal
      v-if="$can('update', 'Creative')"
      id="edit-creative"
      ref="edit-creative"
      hide-footer
      title="Edit creative"
      size="lg"
      @hidden="hideForm"
    >
      <edit-creative
        v-if="selectedCreative"
        :creative="selectedCreative"
        @update-list="hideForm"
      />
    </b-modal>
  </div>
</template>

<script>
import { statusClassesMixin } from '@/utils/mixins.js';
import FilterCreatives from './FilterCreatives.vue';
import EditCreative from './EditCreative.vue';

export default {
  mixins: [statusClassesMixin],
  components: { FilterCreatives, EditCreative },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: {
        id: {
          label: 'ID',
          key: 'id',
          sortable: true,
          tdClass: 'pl-5'
        },
        format: {
          label: 'Format',
          key: 'format',
          sortable: true,
          tdClass: 'pl-5'
        },
        type: {
          label: 'Type',
          key: 'type',
          sortable: true,
          tdClass: 'pl-5'
        },
        creative: {
          label: 'Creative',
          key: 'creative',
          sortable: false,
          tdClass: 'text-center',
          thStyle: {
            width: '200px'
          }
        },
        status: {
          label: 'Status',
          key: 'status',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        actions: {
          label: '',
          key: 'actions',
          thStyle: {
            width: '80px'
          },
          tdClass: 'text-center'
        }
      },
      selectedCreative: null
    };
  },

  computed: {
    tableFields() {
      return !this.isAdmin
        ? this.fields
        : {
            user: {
              label: 'User ID',
              key: 'userId',
              sortable: true,
              tdClass: 'pl-5'
            },
            ...this.fields
          };
    }
  },

  methods: {
    editCreative(creative) {
      // this.$emit('edit-creative', creative);
      this.selectedCreative = creative;
      this.$refs['edit-creative'].show();
    },
    hideForm() {
      this.$refs['edit-creative'].hide();
      this.selectedCreative = {};
      this.$emit('fetch-creatives-list');
    },
    deleteCreative(creativeId) {
      this.$api.adnet.delete(`/dsp/creatives/${creativeId}`).then(
        () => {
          this.$emit('creative-deleted');
          this.$notify('alert', {
            text: `Creative - ID ${creativeId} deleted.`,
            variant: 'success',
            time: 5000
          });
        },
        e => {
          e.response.data.detail &&
            this.$notify('alert', {
              text: e.response.data.detail,
              variant: 'danger',
              time: 0
            });
        }
      );
    }
  }
};
</script>

<style lang="scss">
.creative-preview {
  max-width: 180px;
  width: 100%;
  display: block;
  margin: 0 auto;
}
</style>
